import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { getFeaturesModule } from "../../Helpers/role";
import History from "../../History/History";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { css, cx } from "emotion";
import Profile from "./parts/Profile";
import OperationalTime from "./parts/OperationalTime";
import { withWidth } from "@material-ui/core";
import {
  StyledTabsB,
  StyledTabB,
} from "../../components/CustomStyles/CustomTabs";
import AppStore from "../../Store/AppStore";
import Security from "./parts/Security";
import DeliveryCourier from "./parts/DeliveryCourier";

const Settings = (props) => {
  const { width } = props;
  const [appState, appAction] = AppStore();
  const listFeatures = getFeaturesModule(9);
  const featureActive = listFeatures?.find(
    (feature) => feature?.path === props.location.pathname
  );
  const featureActiveIndex = listFeatures?.findIndex(
    (feature) => feature?.path === props.location.pathname
  );

  const [tabIndex, setTabIndex] = React.useState(
    featureActiveIndex > -1 ? featureActiveIndex : 0
  );
  const [pathActive, setPathActive] = React.useState(
    featureActive ? featureActive?.path : listFeatures?.length > 0 ? listFeatures[0]?.path : ""
  );

  const resetLastVisit = () => {
    localStorage.removeItem("lastVisit")
  }

  React.useEffect(() => {
    resetLastVisit();
    appAction.setNavData({
      mod: 0,
      feat: 0,
      path: "/home",
    })
    if (listFeatures?.length > 0) {
      setPathActive(listFeatures[tabIndex]?.path);
    }
  }, [tabIndex, listFeatures, appAction]);

  return (
    <BaseLayout hiddenSidebar="true">
      <div
        className={
          width === "xs" || width === "sm"
            ? "d-flex flex-column justify-content-start align-items-start"
            : "mt-3 p-3 d-flex justify-content-center align-items-start position-relative"
        }
      >
        {!(width === "xs" || width === "sm") && (
          <button
            type="button"
            className={cx(
              css`
                left: 0;
              `,
              "btn btn-white border-0 rounded-0 position-absolute"
            )}
            onClick={() => History.push("/home")}
          >
            <ArrowBackIcon />
          </button>
        )}

        {(width === "xs" || width === "sm") && (
          <div className="d-flex justify-content-between align-items-between w-100 mb-3">
            <button
              type="button"
              className={cx(
                css`
                  left: 0;
                `,
                "btn btn-white border-0 rounded-0 d-block"
              )}
              onClick={() => History.push("/home")}
            >
              <ArrowBackIcon />
            </button>
            <StyledTabsB
              value={tabIndex}
              onChange={(e, v) => setTabIndex(v)}
              variant="scrollable"
              scrollButtons="auto"
            >
              {listFeatures?.map((feature, index) => {
                return (
                  <StyledTabB key={index} label={feature?.name}></StyledTabB>
                );
              })}
            </StyledTabsB>
          </div>
        )}
        <div className={(width === "xs" || width === "sm") ? "d-flex justify-content-start align-items-start w-100" : "d-flex justify-content-start align-items-start"}>
          {!(width === "xs" || width === "sm") && (
            <ul className="list-group list-group-flush">
              {listFeatures?.map((feature, key) => {
                return (
                  <li
                    key={key}
                    className={
                      feature?.path === pathActive
                        ? "list-group-item font-bold text-primary font-12 p-3 border-0"
                        : "list-group-item font-12 text-muted p-3 cursor-pointer border-0"
                    }
                    onClick={() => setTabIndex(key)}
                  >
                    {/* filter: invert(13%) sepia(1%) saturate(0%) hue-rotate(332deg) brightness(104%) contrast(100%); */}
                    <img
                      src={feature?.icon_url}
                      className={cx(
                        feature?.path === pathActive
                          ? css`
                              width: 32px;
                              height: 32px;
                              filter: invert(13%) sepia(1%) saturate(0%)
                                hue-rotate(332deg) brightness(104%)
                                contrast(100%);
                            `
                          : css`
                              width: 32px;
                              height: 32px;
                              filter: invert(47%) sepia(8%) saturate(506%)
                                hue-rotate(167deg) brightness(93%) contrast(89%);
                            `,
                        "mr-3"
                      )}
                      alt={feature?.name}
                    />{" "}
                    {feature?.name}
                  </li>
                );
              })}
            </ul>
          )}

          {pathActive === "/settings/profile" && (
            <Profile isMobile={width === "xs" || width === "sm"} />
          )}

          {pathActive === "/settings/operationaltime" && (
            <OperationalTime isMobile={width === "xs" || width === "sm"} />
          )}

          {pathActive === "/settings/security" && (
            <Security isMobile={width === "xs" || width === "sm"} />
          )}

          {pathActive === "/settings/deliverycourier" && (
            <DeliveryCourier isMobile={width === "xs" || width === "sm"} />
          )}
        </div>
      </div>
    </BaseLayout>
  );
};

export default withWidth()(Settings);
